import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=df1a6dfc&scoped=true&"
import script from "./TeacherDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=df1a6dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1a6dfc",
  null
  
)

export default component.exports